import React from "react";
import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { Coins } from "lucide-react";

const ICON_MAP = {
  "Gold (24K)": "🥇",
  "Silver": "🥈",
  "Copper": "🟠",
  "Crude Oil (Brent)": "🛢️",
  "Natural Gas": "🔥",
  "USD/INR": "💵",
};

export default function CommodityGrid({ compact = false }) {
  const { data, isLoading } = useQuery({
    queryKey: ["commodities"],
    queryFn: async () => (await api.get("/market/commodities")).data,
    refetchInterval: 45_000,
  });
  const items = data?.data || [];
  return (
    <div className="rounded-2xl bg-white border border-slate-200 overflow-hidden card-glow" data-testid="commodities-grid">
      <div className="flex items-center justify-between px-5 py-4 border-b border-slate-200">
        <div className="flex items-center gap-2">
          <Coins className="w-4 h-4 text-amber-400" />
          <span className="font-heading font-semibold text-slate-900">Commodities & FX</span>
        </div>
        <span className="text-[10px] font-mono-fin text-slate-500 uppercase tracking-widest">Global Spot</span>
      </div>
      <div className={`grid ${compact ? "grid-cols-2 sm:grid-cols-3" : "grid-cols-2 sm:grid-cols-3 lg:grid-cols-3"} gap-0 divide-x divide-y divide-slate-200`}>
        {isLoading && <div className="p-6 text-sm text-slate-500 font-mono-fin col-span-full">Loading…</div>}
        {items.map(c => {
          const up = (c.change || 0) >= 0;
          return (
            <div key={c.symbol} className="p-4 hover:bg-white/[0.02] transition-colors" data-testid={`commodity-card-${c.symbol.toLowerCase().replace(/[^a-z0-9]/g, "-")}`}>
              <div className="flex items-center justify-between mb-1">
                <span className="text-xs font-mono-fin uppercase tracking-wider text-slate-600">{c.symbol}</span>
                <span className="text-lg leading-none">{ICON_MAP[c.symbol] || "◆"}</span>
              </div>
              <div className="font-mono-fin text-lg text-slate-900 font-semibold">{c.price?.toLocaleString('en-US', { minimumFractionDigits: 2 })}</div>
              <div className={`font-mono-fin text-xs mt-0.5 ${up ? "text-[#D91E2A]" : "text-rose-400"}`}>
                {up ? "▲" : "▼"} {Math.abs(c.change).toFixed(2)} ({Math.abs(c.change_pct).toFixed(2)}%)
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
